import styled from 'styled-components'

export const StyledTokenWrap = styled.div`
  background: #fff;
  border: 1px solid #eff0fa;
  box-sizing: border-box;
  box-shadow: 0px 2px 4px rgba(31, 38, 77, 0.054906);
  border-radius: 56px;
  display: inline-flex;
  height: 56px;
  max-width: 165px;
  align-items: center;
  justify-content: space-between;
  padding-left: 12px;
  padding-right: 12px;
  cursor: pointer;

  @media screen and (max-width: 640px) {
    padding: 0 12px 0 6px;
    justify-content: flex-start;
  }
`

export const StyledTokenWrapLeft = styled.div`
  display: flex;
  align-items: center;
  flex: 1;
  margin-right: 4px;
`

export const StyledTokenSymbol = styled.div`
  font-size: 20px;
  font-weight: 400;
  color: #2c2842;
  text-overflow: ellipsis;
  overflow: hidden;
  margin-left: 7px;
`

export const StyledTriangle = styled.img`
  width: 16px;
  height: 16px;
`
